var React = require('react');

function GiantCheck (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M155.499 311C241.382 311 311.001 241.382 311.001 155.5C311.001 69.6201 241.382 0 155.499 0C69.6196 0 0 69.6201 0 155.5C0 241.382 69.6196 311 155.499 311Z","fill":"#F7941D","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M155.499 311C241.382 311 311.001 241.382 311.001 155.5C311.001 69.6201 241.382 0 155.499 0C69.6196 0 0 69.6201 0 155.5C0 241.382 69.6196 311 155.499 311Z","fill":"#F7941D","fillOpacity":"0.7","key":1}),React.createElement("path",{"d":"M88.0391 160.179L133.377 216.859L230.995 94.8105","stroke":"white","strokeWidth":"10","key":2})]);
}

GiantCheck.defaultProps = {"width":"311","height":"311","viewBox":"0 0 311 311","fill":"none"};

module.exports = GiantCheck;

GiantCheck.default = GiantCheck;
